import TableView from 'mini-mail-list-store/lib/store/schema/TableView';

export function getIsItemSelected(tableView: TableView, itemId: string): boolean {
    if (tableView.isInVirtualSelectAllMode) {
        return tableView.virutalSelectAllExclusionList.indexOf(itemId) < 0;
    } else {
        return tableView.isInCheckedMode && tableView.selectedItemsIds.has(itemId);
    }
}
